import { Route, Routes } from "react-router";

import VCSCreateIntegrations from "./Create";
import VCSEditIntegrations from "./Edit";
import { EDIT_INTEGRATIONS_PATH, MANAGE_INTEGRATIONS_PATH } from "./constants";

const VCSIntegrations = () => {
  return (
    <Routes>
      <Route path={EDIT_INTEGRATIONS_PATH} element={<VCSEditIntegrations />} />
      <Route path={MANAGE_INTEGRATIONS_PATH}>
        <Route index path="*" element={<VCSCreateIntegrations />} />
      </Route>
    </Routes>
  );
};

export default VCSIntegrations;
